import type { CSSProperties } from 'react';

export const CHAT_TEXT_SHIMMER_STYLE: CSSProperties = {
  background:
    'linear-gradient(90deg, var(--colors-fg-muted) 25%, var(--colors-fg-subtle) 50%, var(--colors-fg-muted) 75%)',
  backgroundSize: '200% 100%',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  animationTimingFunction: 'linear',
};

export function getChatTextShimmerStyle(
  enabled: boolean,
): CSSProperties | undefined {
  return enabled ? CHAT_TEXT_SHIMMER_STYLE : undefined;
}
